import React from "react";
import { ExternalLink } from "./link";
// @ts-ignore
import AppStoreBadge from '../images/download-on-the-app-store.svg'
// @ts-ignore
import PlayStoreBadge from '../images/en_badge_web_generic.png'

function AppStoreBadges() {
    return <div style={{display: 'flex', justifyContent: 'flex-start'}}>
        <ExternalLink target="_blank" ssx={{mr: 2}} href='https://apps.apple.com/us/app/explore-art-nl/id1569108408?utm_source=public-art-online'>
            <img height="40" src={AppStoreBadge} />
        </ExternalLink>&nbsp;
        <ExternalLink target="_blank" href='https://play.google.com/store/apps/details?id=com.nlba.publicart&utm_source=public-art-online&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img height="40" alt='Get it on Google Play' src={PlayStoreBadge}/>
        </ExternalLink>
    </div>
}

export default AppStoreBadges
